import { lazy } from "react";

// Note: TrackDelivery has a different chunk name now
export const About = lazy(() =>
  import(/* webpackChunkName: "about" */ "./pages/About")
);
export const Trucking = lazy(() =>
  import(/* webpackChunkName: "about" */ "./pages/Trucking")
);
export const Contact = lazy(() =>
  import(/* webpackChunkName: "contact" */ "./pages/Contact")
);
export const Services = lazy(() =>
  import(/* webpackChunkName: "services" */ "./pages/Services")
);
export const TrackDelivery = lazy(() =>
  import(/* webpackChunkName: "tracking" */ "./pages/TrackDelivery")
);
export const BookingForm = lazy(() =>
  import(/* webpackChunkName: "booking" */ "./forms/BookingForm")
);
export const PrivacyPolicy = lazy(() =>
  import(/* webpackChunkName: "legal" */ "./pages/PrivacyPolicy")
);
export const TermsOfService = lazy(() =>
  import(/* webpackChunkName: "legal" */ "./pages/TermsOfService")
);
export const FAQ = lazy(() =>
  import(/* webpackChunkName: "help" */ "./pages/FAQ")
);
export const SuccessPage = lazy(() =>
  import(/* webpackChunkName: "status" */ "./pages/SuccessPage")
);
export const HowItWorks = lazy(() =>
  import(/* webpackChunkName: "help" */ "./pages/HowItWorks")
);
export const VerifiedPage = lazy(() =>
  import(/* webpackChunkName: "status" */ "./pages/VerifiedPage")
);
export const ResetPasswordPage = lazy(() =>
  import(/* webpackChunkName: "auth" */ "./pages/ResetPasswordPage")
);
export const AppPrivacyPolicy = lazy(() =>
  import(/* webpackChunkName: "legal" */ "./pages/AppPrivacyPolicy")
);
export const DataDeletionRequest = lazy(() =>
  import(/* webpackChunkName: "legal" */ "./pages/DataDeletionRequest")
);

export const NotFound = lazy(() =>
  import(/* webpackChunkName: "misc" */ "./pages/NotFound")
);

export const routes = [
  {
    path: "/booking",
    component: BookingForm,
    skeleton: "spinner",
    priority: 1,
  },
  {
    path: "/about",
    component: About,
    skeleton: "page",
  },
  {
    path: "/trucking",
    component: Trucking,
    skeleton: "page",
  },
  {
    path: "/contact",
    component: Contact,
    skeleton: "page",
    priority: 1,
  },
  {
    path: "/services",
    component: Services,
    skeleton: "page",
    priority: 1,
  },
  {
    path: "/track-delivery",
    component: TrackDelivery,
    skeleton: "page",
  },
  // Grouped legal routes
  {
    path: "/privacy-policy",
    component: PrivacyPolicy,
    skeleton: "page",
  },
  {
    path: "/terms-of-service",
    component: TermsOfService,
    skeleton: "page",
  },
  {
    path: "/app-privacy-policy",
    component: AppPrivacyPolicy,
    skeleton: "page",
  },
  {
    path: "/data-deletion-request",
    component: DataDeletionRequest,
    skeleton: "page",
  },
  // Grouped help routes
  {
    path: "/faq",
    component: FAQ,
    skeleton: "page",
  },
  {
    path: "/how-it-works",
    component: HowItWorks,
    skeleton: "page",
  },
  // Grouped status routes
  {
    path: "/success",
    component: SuccessPage,
    skeleton: "page",
  },
  {
    path: "/verified",
    component: VerifiedPage,
    skeleton: "page",
  },
  // Auth route
  {
    path: "/resetpassword",
    component: ResetPasswordPage,
    skeleton: "page",
  },
  // 404 route - no exact needed
  {
    path: "*",
    component: NotFound,
    skeleton: "page",
  },
];
